export enum RisposteChiuse {
  per_nulla = 'PER_NULLA',
  poco = 'POCO',
  abbastanza = 'ABBASTANZA',
  molto = 'MOLTO',
  moltissimo = 'MOLTISSIMO',
}
